import Vue from 'vue';

Vue.directive('focus', {
  inserted: function (el, {value}) {
    if (typeof value === "undefined") {//<input v-focus >
      el.focus();
    } else if (typeof value === "boolean") {//<input v-focus="true">
      if (value) el.focus();
    } else if (typeof value === "object") {//<input v-focus="{focus:true, select:true}">
      if (value.focus) el.focus();
      if (value.select) el.select();
    }
  }
})



// WEBPACK FOOTER //
// ./src/common/js/directive/focus-directive.js